export class CmdEmailTemplate {
    id:string;
    label: string;
    templateId: string;
    organizationId: string;
    requiresAttachment:boolean;
    type: string;
}